export const FETCH_GAME_LIST_REQUEST = 'FETCH_GAME_LIST_REQUEST';
export const FETCH_GAME_LIST_SUCCESS = 'FETCH_GAME_LIST_SUCCESS';
export const FETCH_GAME_LIST_FAILURE = 'FETCH_GAME_LIST_FAILURE';

export const FETCH_CREATE_MATCH_REQUEST = 'FETCH_CREATE_MATCH_REQUEST';
export const FETCH_CREATE_MATCH_SUCCESS = 'FETCH_CREATE_MATCH_SUCCESS';
export const FETCH_CREATE_MATCH_FAILURE = 'FETCH_CREATE_MATCH_FAILURE';

export const FETCH_CREATE_TOURNAMENT_REQUEST = 'FETCH_CREATE_TOURNAMENT_REQUEST';
export const FETCH_CREATE_TOURNAMENT_SUCCESS = 'FETCH_CREATE_TOURNAMENT_SUCCESS';
export const FETCH_CREATE_TOURNAMENT_FAILURE = 'FETCH_CREATE_TOURNAMENT_FAILURE';

export const FETCH_CANCEL_TOURNAMENT_REQUEST = 'FETCH_CANCEL_TOURNAMENT_REQUEST';
export const FETCH_CANCEL_TOURNAMENT_SUCCESS = 'FETCH_CANCEL_TOURNAMENT_SUCCESS';
export const FETCH_CANCEL_TOURNAMENT_FAILURE = 'FETCH_CANCEL_TOURNAMENT_FAILURE';

export const FETCH_GAME_IMAGE_REQUEST = 'FETCH_GAME_IMAGE_REQUEST';
export const FETCH_GAME_IMAGE_SUCCESS = 'FETCH_GAME_IMAGE_SUCCESS';
export const FETCH_GAME_IMAGE_FAILURE = 'FETCH_GAME_IMAGE_FAILURE';

export const FETCH_GAME_TOURNAMENT_LIST_REQUEST = 'FETCH_GAME_TOURNAMENT_LIST_REQUEST';
export const FETCH_GAME_TOURNAMENT_LIST_SUCCESS = 'FETCH_GAME_TOURNAMENT_LIST_SUCCESS';
export const FETCH_GAME_TOURNAMENT_LIST_FAILURE = 'FETCH_GAME_TOURNAMENT_LIST_FAILURE';

export const FETCH_GAME_MATCH_LIST_REQUEST = 'FETCH_GAME_MATCH_LIST_REQUEST';
export const FETCH_GAME_MATCH_LIST_SUCCESS = 'FETCH_GAME_MATCH_LIST_SUCCESS';
export const FETCH_GAME_MATCH_LIST_FAILURE = 'FETCH_GAME_MATCH_LIST_FAILURE';

export const FETCH_ADD_GAME_DEVELOPER_REQUEST = 'FETCH_ADD_GAME_DEVELOPER_REQUEST';
export const FETCH_ADD_GAME_DEVELOPER_SUCCESS = 'FETCH_ADD_GAME_DEVELOPER_SUCCESS';
export const FETCH_ADD_GAME_DEVELOPER_FAILURE = 'FETCH_ADD_GAME_DEVELOPER_FAILURE';

export const FETCH_UPDATE_GAME_DEVELOPER_REQUEST = 'FETCH_UPDATE_GAME_DEVELOPER_REQUEST';
export const FETCH_UPDATE_GAME_DEVELOPER_SUCCESS = 'FETCH_UPDATE_GAME_DEVELOPER_SUCCESS';
export const FETCH_UPDATE_GAME_DEVELOPER_FAILURE = 'FETCH_UPDATE_GAME_DEVELOPER_FAILURE';

export const FETCH_LIST_GAME_DEVELOPER_REQUEST = 'FETCH_LIST_GAME_DEVELOPER_REQUEST';
export const FETCH_LIST_GAME_DEVELOPER_SUCCESS = 'FETCH_LIST_GAME_DEVELOPER_SUCCESS';
export const FETCH_LIST_GAME_DEVELOPER_FAILURE = 'FETCH_LIST_GAME_DEVELOPER_FAILURE';

export const FETCH_DETAIL_GAME_DEVELOPER_REQUEST = 'FETCH_DETAIL_GAME_DEVELOPER_REQUEST';
export const FETCH_DETAIL_GAME_DEVELOPER_SUCCESS = 'FETCH_DETAIL_GAME_DEVELOPER_SUCCESS';
export const FETCH_DETAIL_GAME_DEVELOPER_FAILURE = 'FETCH_DETAIL_GAME_DEVELOPER_FAILURE';

export const RESET_ADMIN_CREATE_TOURNAMENT_REQUEST = 'RESET_ADMIN_CREATE_TOURNAMENT_REQUEST';
